import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from 'src/contexts';
import { useHttp, useNotification } from 'src/common/hooks';
import { LoadingSpinner } from 'src/common/components/loading-spinner/LoadingSpinner';

export function HandleAdminAccount() {
  const { loginWithRedirect, accessToken, logout } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const notify = useNotification();
  const adminId = searchParams.get('id');
  const [isChecked, setIsChecked] = useState(false);
  const [email, setEmail] = useState<string>();
  const { sendRequest: decryptEmail, error: errorDecryptingEmail } = useHttp();
  const { sendRequest: checkInvite, error: errorCheckInvite } = useHttp();

  useEffect(() => {
    if (errorCheckInvite) {
      notify(errorCheckInvite, 'error');
    }

    if (errorDecryptingEmail) {
      notify(errorDecryptingEmail, 'error');
    }
  }, [errorCheckInvite, errorDecryptingEmail]);

  const handleCheckAdminAccount = (email: string) => {
    checkInvite(
      {
        url: `user/check-admin-account/${email}`,
        method: 'GET',
        accessToken,
      },
      (checked: any) => {
        if (checked) setIsChecked(true);
      },
    );
  };

  useEffect(() => {
    if (!adminId) return;

    decryptEmail(
      {
        url: `invites/decrypt/${adminId}`,
        method: 'GET',
        accessToken,
      },
      email => {
        if (email) {
          setEmail(email as string);
          handleCheckAdminAccount(email as string);
        }
      },
    );
  }, [adminId]);

  useEffect(() => {
    if (isChecked && email) {
      logout();
      loginWithRedirect({
        appState: { returnTo: '/complete-admin-signup' },
        screen_hint: 'signup',
        login_hint: email,
      });
    }
  }, [isChecked]);

  return <LoadingSpinner />;
}
